<template>
  <v-dialog v-model="dialog" width="1000" scrollable>
    <v-card>
      <v-toolbar flat color="teal" dark>
        <v-toolbar-title>
          <v-icon left>mdi-barcode-scan</v-icon>
          Auditoría de códigos
          <span v-if="awb">- {{ awb }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip
          v-if="auditResumen"
          small
          dark
          :color="auditResumen.completa ? 'green' : 'orange'"
          class="mr-2"
        >
          Verificadas {{ auditResumen.verificadas }} de {{ auditResumen.total }}
        </v-chip>
        <v-btn @click="dialog = false" small icon dark>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-subtitle v-if="cabeceraId" class="body-2">
        <div>
          Guía: <b>{{ awb }}</b>
          <span v-if="fecha">
            &nbsp;|&nbsp; Fecha: <b>{{ fecha }}</b>
          </span>
          <span v-if="cliente">
            &nbsp;|&nbsp; Cliente: <b>{{ cliente }}</b>
          </span>
        </div>
      </v-card-subtitle>

      <v-card-text>
        <v-form @submit.prevent>
          <v-text-field
            ref="inputBarcodeAudit"
            v-model="auditCodigo"
            label="Escanee el código de barra"
            autofocus
            hide-details
            class="mb-3"
            @keydown="onKeyDownAudit"
            @keydown.enter="escanearCodigoAuditoria()"
            @blur="refocusBarcodeAudit($event)"
            @paste.prevent
            @drop.prevent
            @copy.prevent
            @cut.prevent
          ></v-text-field>
        </v-form>

        <v-row class="mb-3" dense>
          <v-col cols="6" sm="4">
            <v-select
              v-model="filtroEstado"
              :items="opcionesEstado"
              label="Estado"
              item-text="texto"
              item-value="valor"
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="6" sm="4">
            <v-autocomplete
              v-model="filtroFinca"
              :items="fincasOptions"
              label="Finca"
              dense
              clearable
              hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headersAuditoria"
          :items="auditItemsFiltrados"
          :loading="loadingAuditoria"
          dense
          item-key="ID"
          class="elevation-1"
        >
          <template v-slot:item.ESTADO="{ item }">
            <v-chip
              small
              dark
              :color="item.ESTADO === 'VERIFICADO' ? 'green' : 'orange'"
            >
              {{ item.ESTADO === "VERIFICADO" ? "Verificado" : "Pendiente" }}
            </v-chip>
          </template>
          <template v-slot:item.METODO="{ item }">
            <span v-if="item.METODO">{{ item.METODO }}</span>
            <span v-else>-</span>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          color="red"
          dark
          :loading="reiniciandoAuditoria"
          @click="reiniciarAuditoria()"
        >
          <v-icon left>mdi-restore</v-icon> Reiniciar auditoría
        </v-btn>
        <v-btn small @click="dialog = false">
          <v-icon left>mdi-close</v-icon> Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  name: "AuditoriaCajasDialog",
  props: {
    value: { type: Boolean, default: false },
    cabeceraId: { type: [Number, String], default: null },
    awb: { type: String, default: "" },
    fecha: { type: String, default: "" },
    cliente: { type: String, default: "" },
  },
  data() {
    return {
      auditItems: [],
      auditResumen: null,
      auditCodigo: "",
      auditKeyStart: null,
      umbralLectorMs: 200,
      filtroEstado: "ALL",
      filtroFinca: "",
      opcionesEstado: [
        { valor: "ALL", texto: "Todos" },
        { valor: "PENDIENTE", texto: "Pendiente" },
        { valor: "VERIFICADO", texto: "Verificado" },
      ],
      loadingAuditoria: false,
      reiniciandoAuditoria: false,
      headersAuditoria: [
        { text: "Código", value: "BARCODE" },
        { text: "HAWB", value: "HAWB" },
        { text: "Finca", value: "FINCA_NOMBRE" },
        { text: "Cliente final", value: "CLIENTE_FINAL_NOMBRE" },
        { text: "Piezas", value: "PIEZAS" },
        { text: "Gen. por", value: "GENERADO_POR" },
        { text: "Impreso por", value: "IMPRESO_POR" },
        { text: "Fecha impresión", value: "IMPRESO_FECHA" },
        { text: "Ingreso", value: "METODO" },
        { text: "Estado", value: "ESTADO" },
      ],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    fincasOptions() {
      const fincas = [];
      this.auditItems.forEach((it) => {
        if (it.FINCA_NOMBRE && fincas.indexOf(it.FINCA_NOMBRE) === -1) {
          fincas.push(it.FINCA_NOMBRE);
        }
      });
      return fincas.sort();
    },
    auditItemsFiltrados() {
      return this.auditItems.filter((it) => {
        let ok = true;
        if (this.filtroEstado && this.filtroEstado !== "ALL") {
          ok = ok && it.ESTADO === this.filtroEstado;
        }
        if (this.filtroFinca) {
          ok = ok && it.FINCA_NOMBRE === this.filtroFinca;
        }
        return ok;
      });
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.auditCodigo = "";
          this.auditKeyStart = null;
          this.cargarAuditoria();
          this.$nextTick(() => this.refocusBarcodeAudit());
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("master", ["setUrl"]),
    ...mapActions("master", ["requestApi", "alertNotification"]),

    cargarAuditoria() {
      if (!this.cabeceraId) return;
      this.loadingAuditoria = true;
      this.setUrl("api/auditar-precarga-egl");
      this.requestApi({
        method: "GET",
        data: { CABECERA_ID: this.cabeceraId },
      })
        .then((res) => {
          this.auditItems = res.data.items || [];
          this.auditResumen = res.data.resumen || null;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingAuditoria = false;
          this.$nextTick(() => this.refocusBarcodeAudit());
        });
    },

    escanearCodigoAuditoria() {
      const codigo = this.auditCodigo;
      if (!codigo) return;
      const inicio = this.auditKeyStart || Date.now();
      const metodo = Date.now() - inicio <= this.umbralLectorMs ? "LECTOR" : "TECLADO";
      this.auditKeyStart = null;
      this.setUrl("api/escanear-precarga-egl");
      this.requestApi({
        method: "POST",
        data: { CABECERA_ID: this.cabeceraId, CODIGO: codigo, METODO: metodo },
      })
        .then((res) => {
          if (res.data.resumen) this.auditResumen = res.data.resumen;
          this.alertNotification({
            param: {
              html: res.data.msg,
              icon: res.data.success ? "success" : "error",
              title: res.data.success ? "Verificado" : "Aviso",
            },
          });
          this.auditCodigo = "";
          this.cargarAuditoria();
          this.$emit("actualizado");
        })
        .catch((err) => {
          this.alertNotification({
            param: {
              html: (err.response && err.response.data.msg) || "Error al escanear",
              icon: "error",
              title: "Error",
            },
          });
          this.auditCodigo = "";
        })
        .finally(() => this.$nextTick(() => this.refocusBarcodeAudit()));
    },

    reiniciarAuditoria() {
      if (
        !confirm(
          "¿Reiniciar la auditoría de esta guía? Se borrarán los códigos verificados."
        )
      ) {
        return;
      }
      this.reiniciandoAuditoria = true;
      this.setUrl("api/reiniciar-auditoria-precarga-egl");
      this.requestApi({
        method: "POST",
        data: { CABECERA_ID: this.cabeceraId },
      })
        .then((res) => {
          if (res.data.resumen) this.auditResumen = res.data.resumen;
          this.alertNotification({
            param: { html: res.data.msg, icon: "success", title: "Correcto" },
          });
          this.cargarAuditoria();
          this.$emit("actualizado");
        })
        .catch((err) => {
          this.alertNotification({
            param: {
              html: (err.response && err.response.data.msg) || "Error al reiniciar",
              icon: "error",
              title: "Error",
            },
          });
        })
        .finally(() => {
          this.reiniciandoAuditoria = false;
          this.$nextTick(() => this.refocusBarcodeAudit());
        });
    },

    onKeyDownAudit(e) {
      if (
        e.key &&
        e.key.length === 1 &&
        !e.ctrlKey &&
        !e.metaKey &&
        !e.altKey
      ) {
        if (!this.auditKeyStart) this.auditKeyStart = Date.now();
      }
    },

    refocusBarcodeAudit(e) {
      if (!this.dialog) return;
      if (e && e.relatedTarget) return;
      if (this.$refs.inputBarcodeAudit) {
        this.$refs.inputBarcodeAudit.focus();
      }
    },
  },
};
</script>